import ConfirmacionCobro from './ConfirmacionCobro';
export default ConfirmacionCobro;